import store from '@/store';

export default async (to, from, next) => {
  if (!store.getters['user/isTermsAndDistributionRulesAccepted']) {
    next({ name: 'profile' });
  } else {
    next();
  }
};
